import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./index.css";
import { Layout } from "./components/Layout";
import { OverviewPage } from "./routes/Overview";
import { ServicesPage } from "./routes/Services";
import { ServiceDetailPage } from "./routes/ServiceDetail";
import { GroupsPage } from "./routes/Groups";
import { TasksPage } from "./routes/Tasks";
import { TaskDetailPage } from "./routes/TaskDetail";
import { TaskNewPage } from "./routes/TaskNew";
import { RunsPage } from "./routes/Runs";
import { RunDetailPage } from "./routes/RunDetail";
import { FanoutPage } from "./routes/Fanout";
import { DlqPage } from "./routes/Dlq";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <OverviewPage /> },
      { path: "services", element: <ServicesPage /> },
      { path: "services/:id", element: <ServiceDetailPage /> },
      { path: "groups", element: <GroupsPage /> },
      { path: "tasks", element: <TasksPage /> },
      { path: "tasks/new", element: <TaskNewPage /> },
      { path: "tasks/:id", element: <TaskDetailPage /> },
      { path: "tasks/:id/fanout", element: <FanoutPage /> },
      { path: "runs", element: <RunsPage /> },
      { path: "runs/:id", element: <RunDetailPage /> },
      { path: "dlq", element: <DlqPage /> },
    ],
  },
]);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);